<template>
  <div class="h-auto">
    <VVerificationRequiredOverlay />

    <TitledProgressStepper
      :steps="steps"
      class="mb-lg"
    />

    <DocumentsScreen />
  </div>
</template>

<script setup>
// @ts-check
import { useRouter } from 'vue-router/composables';

import { useEnvelopesProgress } from '@/composables/envelopes';
import { useFlagEnabled } from '@/composables/featureFlags/useFlagEnabled';
import { watchFalse } from '@/composables/utils/watchFalse';

import { TitledProgressStepper } from '@/components/library/progressSteppers/TitledProgressStepper';
import DocumentsScreen from '@/components/screens/envelopes/DocumentsScreen';
import VVerificationRequiredOverlay from '@/views/components/VerificationRequiredOverlay.vue';

const { steps } = useEnvelopesProgress();

const router = useRouter();

const [flagLoading, flagEnabled] = useFlagEnabled('new-envelope-flow');

watchFalse(flagLoading, () => {
  if (!flagEnabled.value) {
    router.replace({ name: 'Envelopes' });
  }
});
</script>
